import React from "react";
import { useAdminPage } from "./hooks/useAdminPage";
import { Box } from "@mui/system";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import UserAdmin from "./components/userAdmin";
import OrgAdmin from "./components/orgAdmin";

function AdminPage() {
  const { isLargeScreen } = useAdminPage();

  return (
    <Box
      m={isLargeScreen ? "1.5rem 2rem 2rem 2rem" : "1.5rem 0.5rem 2rem 0.5rem"}
    >
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="Welcome to Deovise Admin Page"
            subtitle="Administer your organisation and users"
          />
        </FlexBetween>
      </WidgetWrapper>
      <OrgAdmin />
      <UserAdmin />
    </Box>
  );
}

export default AdminPage;
